import { AppThunk } from '../../../../../store/types';
import { getConferenceUserGroups } from '../../../../../store/models/selectors';
import { getCurrentAudioId } from '../../../../../store/current-video/selectors';
import { MyStuffUtils } from '../../../../../../common/utils/myStuffUtils';
import { AudioEvents } from '../../Audio/hocs/events';
import { MyLibRecordingsEvents } from '../../../CallRecordingsPage/MyLibRecordings/hocs/events';

export class RecordingActionsEvents {

  public static onDownload(): AppThunk {
    return async (dispatch, getState) => {
      const audioId = getCurrentAudioId(getState());
      if (audioId) await MyStuffUtils.downloadAudio(audioId);
    }
  }

  public static onDownloadCaptions(): AppThunk {
    return async (dispatch, getState) => {
      const audioId = getCurrentAudioId(getState());
      if (audioId) await MyStuffUtils.downloadCaptions(audioId);
    }
  }

  public static onDownloadCaptionsWithTimecodes(): AppThunk {
    return async (dispatch, getState) => {
      const audioId = getCurrentAudioId(getState());
      if (audioId) await MyStuffUtils.downloadCaptionsWithTimecodes(audioId);
    }
  }

  // the tile's own Delete / "Delete for everyone"; back to the list once it's gone
  public static onDelete(forEveryone: boolean): AppThunk {
    return async (dispatch, getState) => {
      const audioId = getCurrentAudioId(getState());
      if (!audioId) return;
      // the group that holds it, not the active one: a direct link may leave those different
      const inGroup = () => getConferenceUserGroups(getState()).find(g => g.audios?.some(a => a.id === audioId));
      const group = inGroup();
      if (!group) return;
      try {
        await dispatch(forEveryone
          ? MyLibRecordingsEvents.onDeleteForEveryone(audioId)
          : MyLibRecordingsEvents.onDelete(group.id, audioId));
      } catch (e) {
        console.error(e);
      }
      // failures leave the recording in its group
      if (!inGroup()) {
        dispatch(AudioEvents.onOpenRecordings());
      }
    }
  }

}
